import { ROUTER } from "@core/constants/router.constants";
import { useService } from "@policoders/di";
import { BreadcrumbService } from "@policoders/ds";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const MainChefsAssistantPage = () => {
  const breadcrumb = useService<BreadcrumbService>("BreadcrumbService");
  useEffect(() => {
    breadcrumb.set([{ label: "Chef's Assistant", value: ROUTER.CHEFS_ASSISTANT.INDEX }]);
  }, [breadcrumb]);

  const navigate = useNavigate();
  const handleFichaTecnica = () => {
    navigate("technical-sheets");
  };
  const handleProdutos = () => {
    navigate("stock/products");
  };
  const handleLivroCaixa = () => {
    navigate("cash-book");
  };

  return (
    <>
      <div className="row gy-3">
        <div className="col-md-12 col-lg-6">
          <div
            className="bg-secondary text-light p-5 rounded"
            role="button"
            onClick={handleLivroCaixa}>
            <h1 className="display-5">Livro caixa</h1>
            <hr />
          </div>
        </div>
        <div className="col-md-12 col-lg-6">
          <div
            className="bg-secondary text-light p-5 rounded"
            role="button"
            onClick={handleFichaTecnica}>
            <h1 className="display-5">Fichas Técnicas</h1>
            <hr />
          </div>
        </div>
        <div className="col-md-12 col-lg-6">
          <div
            className="bg-secondary text-light p-5 rounded"
            role="button"
            onClick={handleProdutos}>
            <h1 className="display-5">Produtos</h1>
            <hr />
          </div>
        </div>
      </div>
    </>
  );
};
